import { useGroupChannelContext } from "@sendbird/uikit-react/GroupChannel/context";

const useSendMessage = () => {
  const { sendUserMessage, currentChannel } = useGroupChannelContext();

  return { sendUserMessage, currentChannel };
};

export default useSendMessage;
